import React, { useState, useContext, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import Autocomplete from "react-google-autocomplete";
import "../../../assets/css/Customer/CustomerDashboard/CustomerInstantRide.css";
import "../../../assets/css/Customer/general/BottomNav.css";
import BottomNav from "../../../components/Customer/general/BottomNav";
import AppContext from "../../../context/AppContext";
import axios from "axios";

const GOOGLE_API_KEY = "AIzaSyCWhWJWmD1OwglKnA6vNsY1xXhKr_QbcW8";

const vehiclesFull = [
  { id: "van", img: "https://cdn-icons-png.flaticon.com/512/3774/3774278.png", name: "Van", tag: "Up to 6" },
  { id: "ac", img: "https://cdn-icons-png.flaticon.com/512/741/741407.png", name: "AC", tag: "Comfort" },
  { id: "mini", img: "https://cdn-icons-png.flaticon.com/512/2554/2554936.png", name: "Mini", tag: "Budget" },
];

const fareMap = {
  van: { base: 350, per_km: 45 },
  ac: { base: 220, per_km: 35 },
  mini: { base: 100, per_km: 18 },
};

function CustomerInstantRide() {
  const navigate = useNavigate();
  const {
    baseUrl, authToken, selectedRideType,
    setSelectedRideforFindingDriver, selectedOffer, setSelectedOffer,
  } = useContext(AppContext);
  const mapRef = useRef(null);

  // Location states
  const [pickuplocation, setpickuplocation] = useState("");
  const [dropofflocation, setdropofflocation] = useState("");
  const [pickupLat, setPickupLat] = useState("");
  const [pickupLng, setPickupLng] = useState("");
  const [dropoffLat, setDropoffLat] = useState("");
  const [dropoffLng, setDropoffLng] = useState("");

  // Ride states
  const [vehicleType, setvehicleType] = useState("ac");
  const [paymentMethod, setPaymentMethod] = useState("");
  const [offeredFare, setofferedFare] = useState("");
  const [bookingType, setBookingType] = useState("");
  const [loading, setLoading] = useState(false);
  const [estKm, setEstKm] = useState(0);
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  // Driver states
  const [driverType, setDriverType] = useState("male");
  const [femaleAvailable] = useState(false);

  // Map modal states
  const [showMapModal, setShowMapModal] = useState(false);
  const [mapTarget, setMapTarget] = useState("pickup");
  const [mapSelectedAddress, setMapSelectedAddress] = useState("");
  const [mapCenter, setMapCenter] = useState({ lat: null, lng: null }); // ✅ new

  // Fare states
  const [customerFareBid, setCustomerFareBid] = useState(0);
  const [fareEdited, setFareEdited] = useState(false);

  const fare = fareMap[vehicleType];
  const systemSuggestedFare = fare.base + fare.per_km * estKm;
  const total = fareEdited ? customerFareBid : Math.round(systemSuggestedFare);
  const discountPercent = selectedOffer ? parseFloat(selectedOffer.discount_percent) : 0;
  const discountAmount = selectedOffer ? Math.round((total * discountPercent) / 100) : 0;
  const finalFareAfterDiscount = selectedOffer ? total - discountAmount : total;
  const canBook = pickuplocation.trim() !== "" && dropofflocation.trim() !== "";

  useEffect(() => {
    if (!fareEdited) setCustomerFareBid(Math.round(systemSuggestedFare));
  }, [systemSuggestedFare, fareEdited]);

  // Distance calculation
  useEffect(() => {
    if (pickuplocation && dropofflocation) {
      const service = new window.google.maps.DistanceMatrixService();
      service.getDistanceMatrix(
        { origins: [pickuplocation], destinations: [dropofflocation], travelMode: window.google.maps.TravelMode.DRIVING },
        (response, status) => {
          if (status === "OK" && response.rows[0].elements[0].status === "OK") {
            setEstKm(parseFloat((response.rows[0].elements[0].distance.value / 1000).toFixed(2)));
          }
        }
      );
    }
  }, [pickuplocation, dropofflocation]);

  // Map modal init
  useEffect(() => {
    if (!showMapModal || !mapRef.current || !window.google) return;
    const defaultCenter = { lat: 31.5204, lng: 74.3587 };
    const map = new window.google.maps.Map(mapRef.current, {
      center: defaultCenter,
      zoom: 14,
      disableDefaultUI: true,
      zoomControl: true,
    });
    const geocoder = new window.google.maps.Geocoder();
    const existingLoc = mapTarget === "pickup" ? pickuplocation : dropofflocation;
    if (existingLoc) {
      geocoder.geocode({ address: existingLoc }, (res, st) => {
        if (st === "OK") map.setCenter(res[0].geometry.location);
      });
    }

    window.google.maps.event.addListener(map, "dragend", () => {
      const center = map.getCenter();
      setMapCenter({ lat: center.lat(), lng: center.lng() }); 
      geocoder.geocode(
        { location: { lat: center.lat(), lng: center.lng() } },
        (res, st) => {
          if (st === "OK" && res[0]) setMapSelectedAddress(res[0].formatted_address);
        }
      );
    });

    // Default center ka address
    geocoder.geocode({ location: defaultCenter }, (res, st) => {
      if (st === "OK" && res[0]) {
        setMapSelectedAddress(res[0].formatted_address);
        setMapCenter(defaultCenter); 
      }
    });
  }, [showMapModal, mapTarget, dropofflocation, pickuplocation]);

  const handleFareBidChange = (val) => {
    if (val === "") { setCustomerFareBid(""); setFareEdited(true); return; }
    const num = parseInt(val);
    if (!isNaN(num) && num >= 0) { setCustomerFareBid(num); setFareEdited(true); }
  };

  const resetFareBid = () => {
    setCustomerFareBid(Math.round(systemSuggestedFare));
    setFareEdited(false);
  };

  const handleBook = () => {
    if (!canBook) return;
    setLoading(true);
    const finalFare = fareEdited ? customerFareBid : total;
    const fareToSend = selectedOffer ? finalFareAfterDiscount : finalFare;
    setofferedFare(fareToSend);

    const formData = new FormData();
    formData.append("pickuplocation", pickuplocation);
    formData.append("pickupLat", pickupLat);
    formData.append("pickupLng", pickupLng);
    formData.append("dropofflocation", dropofflocation);
    formData.append("dropoffLat", dropoffLat);
    formData.append("dropoffLng", dropoffLng);
    formData.append("bookingType", selectedRideType);
    formData.append("paymentmethod", paymentMethod);
    formData.append("vehicleType", vehicleType);
    formData.append("driverType", driverType === "female" && !femaleAvailable ? "top_rated" : driverType);
    formData.append("offeredFare", fareToSend);
    formData.append("status", "request");
    if (selectedOffer) formData.append("offer_id", selectedOffer.id);

    axios.post(`${baseUrl}/customer/ride/createRide`, formData, {
      headers: { "Content-Type": "multipart/form-data", Authorization: `Bearer ${authToken}` },
    })
    .then((response) => {
      setShowSuccessModal(true);
      setTimeout(() => {
        setShowSuccessModal(false);
        setSelectedRideforFindingDriver(response.data.ride);
        setSelectedOffer(null);
        navigate("/customer-finding-driver");
      }, 3000);
    })
    .catch((error) => {
      console.log(error);
      setLoading(false);
      alert("Network Error! Please try again.");
    });
  };

  const resetBooking = () => {
    setBookingType(false);
    setpickuplocation("");
    setdropofflocation("");
  };

  if (bookingType) {
    return (
      <div className="customerInstantRide-page">
        <nav className="customerInstantRide-navbar">
          <button className="customerInstantRide-navbar__back-btn" onClick={resetBooking}>←</button>
          <span className="customerInstantRide-navbar__title">Instant Ride</span>
          <div className="customerInstantRide-navbar__spacer" />
        </nav>
        <Container className="customerInstantRide-main">
          <div className="customerInstantRide-success text-center">
            <div className="customerInstantRide-success__emoji">🎉</div>
            <h3 className="customerInstantRide-success__title">Ride Booked!</h3>
            <p className="customerInstantRide-success__subtitle">Your driver is on the way. Estimated arrival: <strong>5 mins</strong></p>
            <Card className="customerInstantRide-card mt-4 text-start">
              <Card.Body className="p-0">
                {[
                  { label: "From", value: pickuplocation },
                  { label: "To", value: dropofflocation },
                  { label: "Vehicle", value: vehicleType.toUpperCase() },
                  { label: "Driver", value: driverType === "female" && !femaleAvailable ? "Top Rated Driver" : driverType === "female" ? "Female Driver" : "Male Driver" },
                  { label: "Payment", value: paymentMethod === "coin" ? "Coin Exchange" : "Cash" },
                ].map((row) => (
                  <Row key={row.label} className="customerInstantRide-fare__row mx-0 px-3">
                    <Col className="customerInstantRide-fare__label">{row.label}</Col>
                    <Col className="customerInstantRide-fare__value text-end">{row.value}</Col>
                  </Row>
                ))}
                <Row className="customerInstantRide-fare__row customerInstantRide-fare__row--last mx-0 px-3">
                  <Col className="customerInstantRide-fare__label">Your Offer</Col>
                  <Col className="customerInstantRide-fare__value customerInstantRide-fare__value--total text-end">Rs. {offeredFare}</Col>
                </Row>
              </Card.Body>
            </Card>
            <Button className="customerInstantRide-book-btn w-100 mt-3" onClick={() => navigate("/customer/dashboard")}>Go to Dashboard</Button>
          </div>
        </Container>
      </div>
    );
  }

  return (
    <div className="customerInstantRide-page">
      <nav className="customerInstantRide-navbar">
        <button className="customerInstantRide-navbar__back-btn" onClick={() => navigate(-1)}>←</button>
        <span className="customerInstantRide-navbar__title">Instant Ride</span>
        <div className="customerInstantRide-navbar__spacer" />
      </nav>

      <Container className="customerInstantRide-main">
        <div className="customerInstantRide-header">
          <h2 className="customerInstantRide-header__title">Book Instant Ride</h2>
          <p className="customerInstantRide-header__subtitle">Fill in your ride details below</p>
        </div>

        {selectedOffer && (
          <Card className="customerInstantRide-card customerInstantRide-offer-banner">
            <Card.Body>
              <div className="d-flex justify-content-between align-items-center mb-2">
                <span className="customerInstantRide-offer-banner__title">🎉 Offer Applied</span>
                <span className="customerInstantRide-offer-banner__badge">{selectedOffer.discount_percent}% OFF</span>
              </div>
              <p className="customerInstantRide-offer-banner__desc">{selectedOffer.description}</p>
            </Card.Body>
          </Card>
        )}

        {/* Location Card */}
        <Card className="customerInstantRide-card">
          <Card.Body>
            <p className="customerInstantRide-card__title">📍 Location</p>
            <div className="customerInstantRide-location">
              <div className="customerInstantRide-location__line" />

              {/* Pickup */}
              <Row className="customerInstantRide-location__row align-items-center g-0">
                <Col xs="auto">
                  <div className="customerInstantRide-location__dot customerInstantRide-location__dot--pickup">🟢</div>
                </Col>
                <Col style={{ position: "relative" }}>
                  <Autocomplete
                    apiKey={GOOGLE_API_KEY}
                    className="customerInstantRide-location__input form-control"
                    placeholder="Enter pickup location"
                    defaultValue={pickuplocation}
                    onPlaceSelected={(place) => {
                      if (!place || !place.geometry) return;
                      setpickuplocation(place?.formatted_address || place?.name || "");
                      setPickupLat(place.geometry.location.lat()); 
                      setPickupLng(place.geometry.location.lng());
                    }}
                    options={{types: ["establishment", "geocode"], componentRestrictions: { country: "pk" } }}
                  />
                  <button className="customerInstantRide-location__map-pin-btn" onClick={() => { setMapTarget("pickup"); setShowMapModal(true); }} title="Pick on Map">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#1B9B82" /><circle cx="12" cy="9" r="2.5" fill="#ffffff" /></svg>
                  </button>
                </Col>
              </Row>

              {/* Dropoff */}
              <Row className="customerInstantRide-location__row align-items-center g-0 mt-2">
                <Col xs="auto">
                  <div className="customerInstantRide-location__dot customerInstantRide-location__dot--dropoff">📍</div>
                </Col>
                <Col style={{ position: "relative" }}>
                  <Autocomplete
                    apiKey={GOOGLE_API_KEY}
                    className="customerInstantRide-location__input form-control"
                    placeholder="Enter drop-off location"
                    defaultValue={dropofflocation}
                    onPlaceSelected={(place) => {
                      if (!place || !place.geometry) return;
                      setdropofflocation(place?.formatted_address || place?.name || "");
                      setDropoffLat(place.geometry.location.lat()); 
                      setDropoffLng(place.geometry.location.lng()); 
                    }}
                    options={{ types: ["establishment", "geocode"],componentRestrictions: { country: "pk" } }}
                  />
                  <button className="customerInstantRide-location__map-pin-btn" onClick={() => { setMapTarget("dropoff"); setShowMapModal(true); }} title="Pick on Map">
                    <svg width="17" height="17" viewBox="0 0 24 24" fill="none"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#1B9B82" /><circle cx="12" cy="9" r="2.5" fill="#ffffff" /></svg>
                  </button>
                </Col>
              </Row>
            </div>
          </Card.Body>
        </Card>

        {/* Map Modal */}
        <Modal show={showMapModal} onHide={() => setShowMapModal(false)} fullscreen centered className="customerInstantRide-map-modal">
          <Modal.Header className="customerInstantRide-map-modal__header">
            <button className="customerInstantRide-map-modal__back" onClick={() => setShowMapModal(false)}>←</button>
            <span className="customerInstantRide-map-modal__title">
              {mapTarget === "pickup" ? "Select Pickup Location" : "Select Drop-off Location"}
            </span>
          </Modal.Header>
          <Modal.Body className="p-0" style={{ position: "relative" }}>
            <div ref={mapRef} className="customerInstantRide-map-modal__map" />
            <div className="customerInstantRide-map-modal__center-pin">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="none"><path d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7z" fill="#1B9B82" /><circle cx="12" cy="9" r="2.5" fill="#ffffff" /></svg>
            </div>
            <div className="customerInstantRide-map-modal__confirm-wrap">
              {mapSelectedAddress && (
                <div className="customerInstantRide-map-modal__address-bar">
                  <span>📌</span>
                  <span>{mapSelectedAddress}</span>
                </div>
              )}
              
              <Button
                className="customerInstantRide-book-btn w-100"
                onClick={() => {
                  if (mapSelectedAddress && mapCenter.lat) {
                    if (mapTarget === "pickup") {
                      setpickuplocation(mapSelectedAddress);
                      setPickupLat(mapCenter.lat);   
                      setPickupLng(mapCenter.lng);   
                    } else {
                      setdropofflocation(mapSelectedAddress);
                      setDropoffLat(mapCenter.lat); 
                      setDropoffLng(mapCenter.lng);  
                    }
                  }
                  setShowMapModal(false);
                }}
              >
                Confirm Location
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {/* Vehicle Type */}
        <Card className="customerInstantRide-card">
          <Card.Body>
            <p className="customerInstantRide-card__title">Vehicle Type</p>
            <Row className="g-2 justify-content-center">
              {vehiclesFull.map((v) => (
                <Col xs={4} key={v.id}>
                  <div
                    className={`customerInstantRide-vehicle__item ${vehicleType === v.id ? "customerInstantRide-vehicle__item--active" : ""}`}
                    onClick={() => { setvehicleType(v.id); setFareEdited(false); }}
                  >
                    <img src={v.img} alt={v.name} className="customerInstantRide-vehicle__img" />
                    <span className="customerInstantRide-vehicle__name">{v.name}</span>
                    <span className="customerInstantRide-vehicle__tag">{v.tag}</span>
                  </div>
                </Col>
              ))}
            </Row>
          </Card.Body>
        </Card>

        {/* Driver Preference */}
        <Card className="customerInstantRide-card">
          <Card.Body>
            <p className="customerInstantRide-card__title">Driver Preference</p>
            <Row className="g-2">
              <Col xs={6}>
                <div className={`customerInstantRide-driver__item ${driverType === "male" ? "customerInstantRide-driver__item--active" : ""}`} onClick={() => setDriverType("male")}>
                  <div className="customerInstantRide-driver__radio">
                    <div className={`customerInstantRide-driver__radio-dot ${driverType === "male" ? "customerInstantRide-driver__radio-dot--active" : ""}`} />
                  </div>
                  <div className="customerInstantRide-driver__info">
                    <span className="customerInstantRide-driver__name">Male Driver</span>
                  </div>
                </div>
              </Col>
              <Col xs={6}>
                <div className={`customerInstantRide-driver__item ${driverType === "female" ? "customerInstantRide-driver__item--active" : ""} ${!femaleAvailable ? "customerInstantRide-driver__item--unavailable" : ""}`} onClick={() => setDriverType("female")}>
                  <div className="customerInstantRide-driver__radio">
                    <div className={`customerInstantRide-driver__radio-dot ${driverType === "female" ? "customerInstantRide-driver__radio-dot--active" : ""}`} />
                  </div>
                  <div className="customerInstantRide-driver__info">
                    <span className="customerInstantRide-driver__name">Female Driver</span>
                  </div>
                </div>
              </Col>
            </Row>
            {driverType === "female" && !femaleAvailable && (
              <div className="customerInstantRide-driver__notice mt-2">
                <span>⭐</span>
                <span>No female driver available right now. We'll assign a <strong>Top Rated Driver</strong> for you instead.</span>
              </div>
            )}
          </Card.Body>
        </Card>

        {/* Payment Method */}
        <Card className="customerInstantRide-card">
          <Card.Body>
            <p className="customerInstantRide-card__title">💳 Payment Method</p>
            <Row className="g-2">
              <Col xs={12} sm={6}>
                <div className={`customerInstantRide-payment__item ${paymentMethod === "cash" ? "customerInstantRide-payment__item--active" : ""}`} onClick={() => setPaymentMethod("cash")}>
                  <div className="customerInstantRide-payment__icon">💵</div>
                  <div className="customerInstantRide-payment__info">
                    <span className="customerInstantRide-payment__name">Cash</span>
                    <span className="customerInstantRide-payment__desc">Pay on arrival</span>
                  </div>
                  <div className="customerInstantRide-payment__check">✓</div>
                </div>
              </Col>
              <Col xs={12} sm={6}>
                <div className={`customerInstantRide-payment__item ${paymentMethod === "coin" ? "customerInstantRide-payment__item--active" : ""}`} onClick={() => setPaymentMethod("coin")}>
                  <div className="customerInstantRide-payment__icon">🪙</div>
                  <div className="customerInstantRide-payment__info">
                    <span className="customerInstantRide-payment__name">Coin Exchange</span>
                    <span className="customerInstantRide-payment__desc">Use reward coins</span>
                  </div>
                  <div className="customerInstantRide-payment__check">✓</div>
                </div>
              </Col>
            </Row>
          </Card.Body>
        </Card>

        {/* Fare */}
        <Card className="customerInstantRide-card">
          <Card.Body className="p-0">
            <Row className="customerInstantRide-fare__row mx-0 px-3">
              <Col className="customerInstantRide-fare__label">Suggested Fare</Col>
              <Col className="customerInstantRide-fare__value text-end">Rs. {Math.round(systemSuggestedFare)}</Col>
            </Row>
            <div className="customerInstantRide-bid__section mx-3 mb-3">
              <div className="customerInstantRide-bid__label">
                <span>💬 Your Fare Offer</span>
                {fareEdited && <button className="customerInstantRide-bid__reset" onClick={resetFareBid}>Reset to suggested</button>}
              </div>
              <div className="customerInstantRide-bid__input-wrap">
                <span className="customerInstantRide-bid__currency">Rs.</span>
                <input type="number" className="customerInstantRide-bid__input" value={customerFareBid} onChange={(e) => handleFareBidChange(e.target.value)} min={0} />
              </div>
              <p className="customerInstantRide-bid__hint">
                {fareEdited ? customerFareBid < Math.round(systemSuggestedFare) ? "⚠️ Lower offer may take longer to find a driver" : "✅ Good offer! Driver will likely accept quickly" : "You can adjust this amount. Driver will accept or counter offer."}
              </p>
            </div>

            {selectedOffer && (
              <div className="mx-3 mb-3 customerInstantRide-discount-summary">
                <div className="d-flex justify-content-between mb-1 customerInstantRide-discount-summary__row">
                  <span>Original Fare</span>
                  <span className="customerInstantRide-discount-summary__original-fare">Rs. {total}</span>
                </div>
                <div className="d-flex justify-content-between mb-2 customerInstantRide-discount-summary__row">
                  <span>Offer Discount ({selectedOffer.discount_percent}%)</span>
                  <span>- Rs. {discountAmount}</span>
                </div>
                <hr className="customerInstantRide-discount-summary__divider" />
                <div className="d-flex justify-content-between customerInstantRide-discount-summary__total-row">
                  <span>You Pay</span>
                  <span>Rs. {finalFareAfterDiscount}</span>
                </div>
              </div>
            )}
          </Card.Body>
        </Card>

        <Button className="customerInstantRide-book-btn w-100" onClick={handleBook} disabled={!canBook || loading}>
          {loading ? "Finding your driver..." : "Book Ride"}
        </Button>

        {!canBook && <p className="customerInstantRide-hint text-center mt-2">Please enter pickup & drop-off to continue</p>}

        {/* Success Modal */}
        <Modal show={showSuccessModal} centered backdrop="static" className="booking-success-modal">
          <Modal.Body className="text-center p-5">
            <div className="customerInstantRide-success-modal__emoji">🎉</div>
            <h3 className="customerInstantRide-success-modal__title">Congratulations!</h3>
            <p className="customerInstantRide-success-modal__text">
              Your ride has been booked successfully. <br /><strong>Finding a driver for you...</strong>
            </p>
            <div className="spinner-border mt-3 customerInstantRide-success-modal__spinner" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </Modal.Body>
        </Modal>

        <div className="customerInstantRide-bottom-space" />
      </Container>
      <BottomNav />
    </div>
  );
}

export default CustomerInstantRide;